
import { GlobalController } from 'src/shared/global/GlobalController'
import ProfilePermission from './profile-permission/ProfilePermission'

const ifAuthenticated = (to, from, next) => {
  GlobalController.getAsyncInstance().then(data => {
    if (data && data.authResp && data.authResp.token) {
      next()
    } else {
      next('/')
    }
  })
}
export const routes = [
  {
    path: 'ProfilePermission',
    name: 'profile-permission',
    component: ProfilePermission,
    beforeEnter: ifAuthenticated,
    props: true
  }
]
